import { useEffect } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

export function useOnNavigateIn(callback: () => void) {
  const location = useLocation();
  const routeMatch = useRouteMatch();
  const isExactMatch = routeMatch.isExact && location.pathname === routeMatch.url;
  useEffect(() => {
    if (isExactMatch) {
      callback();
    }
  }, [callback, isExactMatch]);
}
